export default {
    navigationBarTitleText: '技术授权专题',
    navigationBarBackgroundColor: "#DF773C",
};
